import { useCallback } from "react";
import useAxios from "@libs/axios/useAxios";
import {
  BRAND_EXPLORE,
  BRAND_SORT_URL,
  GET_BRAND_URL,
  GET_CATEGORY_URL,
  GET_COLOR_URL,
  GET_CONDITION_URL,
  GET_FAQ_CATEGORY_URL,
  GET_FAQ_LIST_URL,
  GET_NEWS_LIST_URL,
  INVENTORY_URL,
  GET_SIZE_URL,
  GET_SIZE_TYPE_URL,
  GET_USER_INFO_URL,
  POPUP_URL,
  PROMOTION_URL,
  SELLER_URL,
  WE_LOVES_URL,
  CHECK_DUPLICATE_NICKNAME,
  EMAIL_VERIFICATION_URL,
  GET_EMAIL_VERIFICATION_URL,
  MEMBER_URL,
  GET_GENDER_LIST_URL,
  SIGN_IN_URL,
  GET_SHIPPING_ADDRESS,
  PATCH_SHIPPING_ADDRESS,
  PRODUCT_POPUP_URL,
  BANK_LIST_URL,
  PATCH_PASSWORD_URL,
  GET_PRODUCT_SORT_URL,
  FIND_PASSWORD_EMAIL_VERIFICATION_URL,
  GET_FIND_PASSWORD_EMAIL_VERIFICATION_URL,
  FIND_PASSWORD_URL,
  DEACTIVATE_URL,
  CHECK_EMAIL_URL,
  COUNTRY_URL,
  INVENTORY_STATISTICS_URL,
  PRODUCT_CHARGE_RATE_URL,
  GET_PRODUCT_INVENTORY_SIMPLE_URL,
  POST_INVENTORY_TEMP_URL,
  DELETE_INVENTORY_TEMP_PRODUCT_URL,
  POST_PRODUCT_URL,
  AI_URL,
  GET_AI_DATA_URL,
  POST_PRODUCT_TEMP_URL,
  DELETE_PRODUCT_TEMP_URL,
  GET_INVENTORY_SORT_CODE_URL,
  PATCH_USER_ACTIVATE_URL,
  GET_AI_COLOR_URL,
  GET_TAG_URL,
  GET_AUDIENCE_CATEGORY_URL,
  COLOR_SUGGESTIONS_URL
} from "@libs/apiUrl";
import axios from "axios";

export const useApiRequest = () => {
  const { axiosInstance } = useAxios();


// 재고

// 재고 상품목록 정렬
const getInventorySortCode = useCallback(async () => {
  const res = await axiosInstance.get(GET_INVENTORY_SORT_CODE_URL);

  if (res.status === 200) {
    return res.data.data;
  }
}, [axiosInstance]);

  // 재고관리 상품 통계 조회
  const getInventoryStatistics = useCallback(async () => {
    const res = await axiosInstance.get(INVENTORY_STATISTICS_URL);
    if (res.status === 200) {
      return res.data.data;
    }
  }, [axiosInstance]);


  // 상품 등록 내역 간소화 조회
  const getProductInventorySimple = useCallback(async ( ) => {
    const res = await axiosInstance.get(GET_PRODUCT_INVENTORY_SIMPLE_URL);
    if (res.status === 200) {
      return res.data.data;
    }
  }, [axiosInstance]);


  // 상품 등록 내역 상세 조회
  const getProductDetail = useCallback(
    async (productId: any, status: any) => {
      try {
        const res = await axiosInstance.get(
          `${INVENTORY_URL}/${productId}?status=${status}`,
        );
        if (res.status === 200) {
          return res.data.data;
        }
      } catch (error) {
        console.error("Error fetching product details:", error);
        throw error;
      }
    },
    [axiosInstance],
  );

// 등록 상품 재고 조회
  const getProductStock = useCallback(
    async (productId: number, status: string ) => {
      const res = await axiosInstance.get(
        `${INVENTORY_URL}/${productId}/stock?status=${status}`,
      );
      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );


  // 재고 상품 저장 
  const postProductStock = useCallback(
    async (data: any) => {
      const res = await axiosInstance.post(INVENTORY_URL, data);
      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  )

  // 재고 상품 수정
  const updateProductStockTemp = useCallback(
    async (productId: number, data: any) => {
      const res = await axiosInstance.patch(
        `${INVENTORY_URL}/${productId}`, 
        data,
      );
      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  // 재고관리 상품 삭제
  const deleteProductStock = useCallback(
    async (productId: number) => {
      const res = await axiosInstance.delete(`${INVENTORY_URL}/${productId}`);
      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  )

  // 재고관리 상품 임시 저장
  const postProductStockTemp = useCallback(
    async (data: any) => {
      const res = await axiosInstance.post(POST_INVENTORY_TEMP_URL, data);
      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  )

  // 재고관리 상품 임시저장 삭제
  const deleteProductStockTemp = useCallback(
    async (productId: number) => {
      const res = await axiosInstance.delete(`${DELETE_INVENTORY_TEMP_PRODUCT_URL}/${productId}`);
      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  )

// ** 상품

// 상품 등록
const postProduct = useCallback(
  async (data: any) => {
    const res = await axiosInstance.post(POST_PRODUCT_URL, data);
    if (res.status === 200) {
      return res.data.data;
    }
  },
  [axiosInstance],
)

  //  상품 임시 저장
  const postProductTemp = useCallback(
  async (data: any) => {
    const res = await axiosInstance.post(POST_PRODUCT_TEMP_URL, data);
    if (res.status === 200) {
      return res.data.data;
    }
  },
  [axiosInstance],
)

// 상품 임시 저장 삭제
const deleteProductTemp = useCallback(
  async (productId: number) => {
    const res = await axiosInstance.delete(`${DELETE_PRODUCT_TEMP_URL}/${productId}`);
    if (res.status === 200) {
      return res.data.data;
    }
  },
  [axiosInstance],
);
// ** AI

// AI 학습용 데이터 저장
const postAiTrainingData = useCallback(
  async (data: any) => {
    console.log("[API] postAiTrainingData 요청:", AI_URL, data);
    const res = await axiosInstance.post(AI_URL, data);
    console.log("[API] postAiTrainingData 응답:", {
      status: res.status,
      data: res.data,
      dataData: res.data?.data,
    });
    if (res.status >= 200 && res.status < 300) {
      return res.data.data;
    }
    throw new Error(`AI 학습 데이터 저장 실패: ${res.status}`);
  },
  [axiosInstance],
);

// AI 색상 id 조회
const getColorId = useCallback(async (colorId: string) => {
  const res = await axiosInstance.get(`${GET_AI_COLOR_URL}?ai_color_id=${colorId}`);
  if (res.status === 200) {
    return res.data.data;
  }
}, [axiosInstance]);

// AI 학습용 데이터 조회
const getAiTrainingData = useCallback(async (productId: number) => {
  const res = await axiosInstance.get(`${GET_AI_DATA_URL}/${productId}`);
  if (res.status === 200) {
    return res.data.data;
  }
}, [axiosInstance]);

// 태그 목록 조회
const getTagList = useCallback(async (attributeCode?: string) => {
  const url = attributeCode
    ? `${GET_TAG_URL}?attribute_code=${attributeCode}`
    : GET_TAG_URL;
  const res = await axiosInstance.get(url);
  if (res.status === 200) {
    return res.data.data;
  }
}, [axiosInstance]);

const getAudienceCategoryList = useCallback(async () => {
  const res = await axiosInstance.get(GET_AUDIENCE_CATEGORY_URL);
  return res.status === 200 ? res.data.data : [];
}, [axiosInstance]);

const getColorSuggestions = useCallback(async (image: File | Blob) => {
  const formData = new FormData();
  formData.append("image", image, image instanceof File ? image.name : "product.jpg");
  const res = await axiosInstance.post(COLOR_SUGGESTIONS_URL, formData);
  return res.status === 200 ? res.data.data?.suggestions || [] : [];
}, [axiosInstance]);

  // *********************************************

    // 상품 요율 조회
    const getProductRate = useCallback(async () => {
      const res = await axiosInstance.get(PRODUCT_CHARGE_RATE_URL);
  
      if (res.status === 200) {
        return res.data.data;
      }
    }, [axiosInstance]);

  //COLOR LIST
  const getColorList = useCallback(async () => {
    const res = await axiosInstance.get(GET_COLOR_URL);

    if (res.status === 200) {
      return res.data.data;
    }
  }, [axiosInstance]);

  //SIZE LIST
  const getSizeList = useCallback(async (sizeTypeId: number) => {
    if (!sizeTypeId) return [];
    const res = await axiosInstance.get(`${GET_SIZE_URL}?size_type_id=${sizeTypeId}`);

    if (res.status === 200) {
      return (res.data.data || []).map((item: any) => ({
        ...item,
        code: item.id,
        name_ko: item.name,
        name_en: item.name,
      }));
    }
    return [];
  }, [axiosInstance]);

  //SIZE TYPE LIST
  const getSizeTypeList = useCallback(async () => {
    const res = await axiosInstance.get(GET_SIZE_TYPE_URL);

    if (res.status === 200) {
      return res.data.data || [];
    }
    return [];
  }, [axiosInstance]);

  //유저 정보
  const getUserInfo = useCallback(async () => {
    const res = await axiosInstance.get(GET_USER_INFO_URL);

    if (res.status === 200) {
      return res.data.data;
    }
    return null;
  }, [axiosInstance]);

  //셀러 정보
  const getSellerInfo = useCallback(
    async (sellerId: number) => {
      const res = await axiosInstance.get(`${SELLER_URL}/${sellerId}`);

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  //컨디션 리스트
  const getConditionList = useCallback(async () => {
    const res = await axiosInstance.get(GET_CONDITION_URL);

    if (res.status === 200) {
      return (res.data.data || []).map((item: any) => ({
        ...item,
        name_ko: item.value_ko,
        name_en: item.value_en,
      }));
    }
    return [];
  }, [axiosInstance]);

  //브랜드 리스트
  const getBrandList = useCallback(async () => {
    const res = await axiosInstance.get(GET_BRAND_URL);

    if (res.status === 200) {
      return (res.data.data || []).map((item: any) => ({
        ...item,
        code: item.id,
      }));
    }
    return [];
  }, [axiosInstance]);

  //브랜드 정렬 리스트
  const getBrandSortList = useCallback(async () => {
    const res = await axiosInstance.get(BRAND_SORT_URL);

    if (res.status === 200) {
      return res.data.data;
    }
  }, [axiosInstance]);

  //카테고리 리스트
  const getCategoryList = useCallback(
    async (parentId?: number | null) => {
      const url = parentId
        ? `${GET_CATEGORY_URL}?parent_id=${parentId}`
        : GET_CATEGORY_URL;

      try {
        const res = await axiosInstance.get(url);

        if (res.status === 200) {
          return (res.data.data || []).map((item: any) => ({
            ...item,
            // code 는 드롭다운 선택값이자 parent_id 로 다시 나가는 값이라 항상 숫자 id 여야 한다.
            // category.code('UNISEX','GOODS')는 문자열이라 그대로 쓰면 parent_id=UNISEX 로 나가 400 이 난다.
            code: item.id,
            category_code: item.code ?? null,
            name_ko: item.name_ko ?? item.nameKo,
            name_en: item.name_en ?? item.nameEn,
            name_ja: item.name_ja ?? item.nameJa,
            parent_id: item.parent_id ?? item.parentId ?? null,
            has_children: item.has_children ?? item.hasChildren ?? false,
            size_type_id: item.size_type_id ?? item.sizeTypeId ?? null,
            is_active: item.is_active ?? item.isActive ?? true,
            sort_order: item.sort_order ?? item.sortOrder ?? null,
          }));
        }
      } catch (error) {
        console.error("카테고리 목록을 가져오는 중 에러 발생:", error);
      }
    },
    [axiosInstance],
  );



  //Size with stock
  const getSizeWithStock = useCallback(
    async (productId: number, colorId: number | null) => {
      const res = await axiosInstance.get(
        `${INVENTORY_URL}/${productId}/${colorId}/size`,
      );

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );



  //We Loves 상품 리스트
  const getWeLovesList = useCallback(async (categoryId: number) => {
    const res = await axios.get(`${WE_LOVES_URL}?category_id=${categoryId}`);

    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  //도매 브랜드 탐험
  const getBrandExploreList = useCallback(async () => {
    const res = await axios.get(BRAND_EXPLORE);

    if (res.status === 200) {
      return res.data.data;
    }
  }, []);


  //로그인 팝업 이미지
  const getPopup = useCallback(async () => {
    const res = await axios.get(POPUP_URL);

    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  // 홈 프로모션 리스트
  const getPromotionList = useCallback(async (categoryId: number) => {
    const res = await axios.get(`${PROMOTION_URL}?category_id=${categoryId}`);

    if (res.status === 200) {
      return res.data.data;
    }
  }, []);




  //FAQ 카테고리
  const getFaqCategory = useCallback(async () => {
    const res = await axios.get(GET_FAQ_CATEGORY_URL);

    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  // FAQ 리스트
  const getFaqList = useCallback(
    async (category: string) => {
      const res = await axiosInstance.get(
        `${GET_FAQ_LIST_URL}?category=${category}`,
      );

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  // NEWS 리스트
  const getNewsList = useCallback(async () => {
    const res = await axiosInstance.get(`${GET_NEWS_LIST_URL}`);

    if (res.status === 200) {
      return res.data.data;
    }
  }, [axiosInstance]);




  // 닉네임 중복체크
  const getNicknameCheck = useCallback(
    async (nickName: string) => {
      const res = await axiosInstance.get(
        `${CHECK_DUPLICATE_NICKNAME}/${nickName}`,
      );
      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  // POST 인증링크 전송
  const postVerifyEmail = useCallback(
    async (login_id: string, language: string) => {
      const res = await axios.post(EMAIL_VERIFICATION_URL, {
        email: login_id,
        language: language,
      });

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [],
  );

  // 비밀번호찾기 이메일 인증하기
  const postFindPasswordEmail = useCallback(
    async (login_id: string, language: string) => {
      const res = await axios.post(FIND_PASSWORD_EMAIL_VERIFICATION_URL, {
        email: login_id,
        language: language,
        service: "inventory",
      });
      if (res.status === 200) {
        return res.data.data;
      }
    },
    [],
  );

  // GET 이메일 인증하기
  const getVerifyEmail = useCallback(async (verification_code: string) => {
    const res = await axios.get(
      `${GET_EMAIL_VERIFICATION_URL}?verification_code=${verification_code}`,
    );
    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  // 비밀번호 찾기 인증
  const getFindPassword = useCallback(async (verification_code: string) => {
    const res = await axios.get(
      `${GET_FIND_PASSWORD_EMAIL_VERIFICATION_URL}?verification_code=${verification_code}`,
    );
    if (res.status === 200) {
      return res.data.data;
    }
  }, []);


  // 회원 활성화 
  const patchUserActivate = useCallback(async (verification_code: string) => {
    const res = await axios.patch(
      `${PATCH_USER_ACTIVATE_URL}/${verification_code}`);
    if (res.status === 200) {
      return res.data.data;
    }
  }, []);



  const getGenderList = useCallback(async () => {
    const res = await axios.get(GET_GENDER_LIST_URL);
    if (res.status === 200) {
      return res.data.data;
    }
  }, []);

  // 프로필 데이터 업데이트
  const patchProfile = useCallback(async (data: any) => {
    const res = await axiosInstance.patch(MEMBER_URL, data);
    if (res.status === 200) {
      return res.data.data;
    }
  }, [axiosInstance]);

  const postLogin = useCallback(async (data: any) => {
    const res = await axios.post(SIGN_IN_URL, data, { withCredentials: true });
    if (res.status === 200) {
      return res;
    }
  }, []);



  // 배송지 가져오기
  const getDeliveryList = useCallback(async () => {
    const res = await axiosInstance.get(GET_SHIPPING_ADDRESS);
    if (res.status === 200) {
      return res.data.data;
    }
  }, [axiosInstance]);

  // 배송지 수정하기
  const updateDelivery = useCallback(async (postData: any) => {
    const res = await axiosInstance.patch(PATCH_SHIPPING_ADDRESS, postData);
    if (res.status === 200) {
      return res.data.data;
    }
  }, [axiosInstance]);

  const getProductPopup = useCallback(async () => {
    const res = await axiosInstance.get(`${PRODUCT_POPUP_URL}`);
    if (res.status === 200) {
      return res.data.data;
    }
  }, [axiosInstance]);


  //은행 목록
  const getBankList = async () => {
    const res = await axios.get(`${BANK_LIST_URL}`);
    if (res.status === 200) {
      return res.data.data;
    }
  };




  // 비밀번호 변경
  const patchChangePassword = useCallback(
    async (data: any) => {
      const res = await axiosInstance.patch(PATCH_PASSWORD_URL, data);

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  // 비밀번호 찾기 변경
  const patchFindPassword = useCallback(
    async (data: any) => {
      const res = await axiosInstance.patch(FIND_PASSWORD_URL, data);

      if (res.status === 200) {
        return res.data.data;
      }
    },
    [axiosInstance],
  );

  // 상품 정렬
  const getProductSort = useCallback(async () => {
    const res = await axiosInstance.get(GET_PRODUCT_SORT_URL);

    if (res.status === 200) {
      return res.data.data;
    }
  }, [axiosInstance]);

  // 탈퇴하기
  const patchDeactivate = useCallback(async () => {
    const res = await axiosInstance.patch(DEACTIVATE_URL);

    if (res.status === 200) {
      return res.data.data;
    }
  }, [axiosInstance]);





  // 이메일 체크
  const getCheckEmail = useCallback(async (email: any) => {
    const res = await axios.get(
      `${CHECK_EMAIL_URL}/check-exists?email=${email}`,
    );

    if (res.status === 200) {
      return res.data.data;
    }
  }, []);


  // 국가
  const getCountry = useCallback(async () => {
    const res = await axios.get(`${COUNTRY_URL}`);

    if (res.status === 200) {
      return res.data.data;
    }
  }, []);




  return {
    getColorList,
    getSizeList,
    getSizeTypeList,
    getUserInfo,
    getConditionList,
    getCategoryList,
    getProductDetail,
    getSizeWithStock,
    getBrandList,
    getBrandSortList,
    getSellerInfo,
    getWeLovesList,
    getBrandExploreList,
    getPopup,
    getPromotionList,
    getFaqCategory,
    getFaqList,
    getNewsList,
    patchUserActivate,

    getNicknameCheck,
    postVerifyEmail,
    getVerifyEmail,
    getGenderList,
    patchProfile,
    postLogin,

    postFindPasswordEmail,
    getDeliveryList,
    updateDelivery,

    getProductPopup,
    getBankList,

    patchChangePassword,
    getProductSort,
    getFindPassword,
    patchFindPassword,
    patchDeactivate,
 
    getCheckEmail,
    getProductRate,
    getCountry,

    getInventorySortCode,
    getInventoryStatistics,
    getProductInventorySimple,
    getProductStock,
    postProductStock,
    updateProductStockTemp,
    postProductStockTemp,
    deleteProductStock,
    deleteProductStockTemp,
    postProduct,
    postProductTemp,
    deleteProductTemp,


    postAiTrainingData,
    getColorId,
    getAiTrainingData,
    getTagList,
    getAudienceCategoryList,
    getColorSuggestions
  };
};
